export function convertTimestamp(timestamp) {
  // 1. 將timestamp字符串轉換成毫秒
  const date = new Date(timestamp);

  // 2. 格式化日期
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() 回傳 0-11，所以需要加 1
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const second = String(date.getSeconds()).padStart(2, '0');

  // 3. 拼接最终的字符串
  const formattedDate = `${year}/${month}/${day} ${hour}:${minute}:${second}`;

  return formattedDate;
}

export function isIncludingCurrentYear(start, end) {
  const currentYear = new Date().getFullYear(); // 取得今年 (例如 2026)
  
  const startDate = new Date(start);
  const endDate = new Date(end);
  
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();

  // 判斷邏輯：今年是否介於開始年份與結束年份之間
  return currentYear >= startYear && currentYear <= endYear;
}

export function compareDates(dateStr1, dateStr2) {
  const d1 = new Date(dateStr1);
  const d2 = new Date(dateStr2);

  if (d1 > d2) return 1;
  if (d1 < d2) return -1;
  return 0;
}

export function processDateRange(inputDateStr) {
  const inputDate = new Date(inputDateStr);
  const now = new Date();
  const currentYear = now.getFullYear();

  // 建立「今年 1/1」的基準點 (2026-01-01T00:00:00)
  const currentYearFirstDay = new Date(currentYear, 0, 1);

  let targetDate;

  if (inputDate < currentYearFirstDay) {
    // 1. 如果小於今年，回傳今年/01/01
    targetDate = currentYearFirstDay;
  } else {
    // 2. 如果大於或等於今年，使用原始日期
    targetDate = inputDate;
  }

  // 格式化輸出為 yyyy/mm/dd
  const y = targetDate.getFullYear();
  const m = String(targetDate.getMonth() + 1).padStart(2, '0');
  const d = String(targetDate.getDate()).padStart(2, '0');

  return `${y}/${m}/${d}`;
}

export function formatDate(dateString) {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}/${month}/${day}`;
}

export function getCurrentDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
